import React from 'react';
import PropTypes from 'prop-types';
import TechnicalDocument from './TechnicalDocument';

const TechnicalDocumentModal = props => (
  <div id="documentListCont" className="documentListContainer">
    <div className="documentListHeader">
      <span className="bold right20">{props.labels.rsUpdate}</span>
      <span className="bold right20">{props.labels.revision}</span>
      <span className="bold">{props.labels.language}</span>
    </div>
    <div className="docSection" id="technical-section">
      <div className="docSectionTitle">{props.labels.technicalDocuments}</div>
      <table className="docListTable" border="0" width="100%">
        <tbody>
          {
            props.documents.map(document =>
              <TechnicalDocument key={document.id} {...document} />,
            )
          }
        </tbody>
      </table>
    </div>
  </div>
);

TechnicalDocumentModal.propTypes = {
  labels: PropTypes.shape({
    rsUpdate: PropTypes.string,
    revision: PropTypes.string,
    language: PropTypes.string,
    technicalDocuments: PropTypes.string,
  }),
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    created: PropTypes.number,
    updated: PropTypes.number,
    language: PropTypes.string,
    latestRevision: PropTypes.number,
    type: PropTypes.string,
    format: PropTypes.string,
    revisions: PropTypes.shape({
      path: PropTypes.string,
      revision: PropTypes.number,
      manufacturerRevision: PropTypes.string,
      extension: PropTypes.string,
      size: PropTypes.number,
      created: PropTypes.string,
    }),
    href: PropTypes.string,
  })),
};

TechnicalDocumentModal.defaultProps = {
  labels: {},
  documents: [],
};

export default TechnicalDocumentModal;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/TechnicalDocument/TechnicalDocumentModal.js